import React from "react";
import "./ImagesSlider.css";

// Import your images
import imageslider1 from "../assets/Slider1.jpeg";
import imageslider2 from "../assets/Slider2.jpeg";
import imageslider3 from "../assets/Slider3.jpeg";
import imageslider4 from "../assets/Slider4.jpeg";
import imageslider5 from "../assets/Slider5.jpeg";

const ImagesSlider = () => {
  const slides = [
    {
      id: 1,
      title: "Annadaan Seva",
      image: imageslider1,
    },
    {
      id: 2,
      title: "Gau Seva",
      image: imageslider2,
    },
    {
      id: 3,
      title: "Visesh Navidya Seva",
      image: imageslider3,
    },
    {
      id: 4,
      title: "Spritual Discourses",
      image: imageslider4,
    },
    {
      id: 5,
      title: "Spritual Discourses",
      image: imageslider5,
    },
  ];

  // Duplicate slides for seamless infinite loop
  const duplicatedSlides = [...slides, ...slides, ...slides];

  return (
    <div className="images-slider-container pt-8">
      <div className="slider-wrapper">
        <div className="slider-track">
          {duplicatedSlides.map((slide, index) => (
            <div key={`${slide.id}-${index}`} className="slider-slide">
              <div className="slide-image">
                <img src={slide.image} alt={slide.title} />
              </div>
              {/* <div className="slide-content">
                <h3 className="slide-title">{slide.title}</h3>
              </div> */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImagesSlider;
